import { gql } from '@apollo/client';

const replaceVoucher = gql`
  mutation replaceVoucher($amount: Float!, $reason: String!, $voucherToReplace: String!) {
    replaceVoucher(amount: $amount, reason: $reason, voucherToReplace: $voucherToReplace) {
      alias
    }
  }
`;

export default replaceVoucher;
